var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTentAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93723 2C7.33667 2 7.66048 2.32365 7.66048 2.72289V4.6506H16.3395V2.72289C16.3395 2.32365 16.6633 2 17.0627 2C17.4622 2 17.786 2.32365 17.786 2.72289V4.6506L21.9285 19.5563C22.2699 20.7847 21.3457 22 20.0702 22H11.0357L6.31771 5.02382C6.25187 4.91488 6.21399 4.78716 6.21399 4.6506V2.72289C6.21399 2.32365 6.5378 2 6.93723 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9729 22V9.18506L9.53438 22H5.9729Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52643 10.7229L2.07148 19.5563C1.73011 20.7847 2.65432 22 3.92979 22H4.52643V10.7229Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentAlt1);
export default __webpack_public_path__ + "static/media/tent-alt-1.3bcfb05368f3a6931339d6672ff5b17f.svg";
export { ForwardRef as ReactComponent };